export const updateRemainingPersonEmailFields = (
    index: number,
    fields: any[],
    update: (arg1: number, arg2: any) => void
) => {
    const fieldData = setSingleRemainingPersonEmailFieldToNotRemovable(index, fields);

    if (fieldData.updatedField && fieldData.index) {
        update(fieldData.index, fieldData.updatedField);
    }
};

// Tested in email-field-helpers.spec.js
export const setSingleRemainingPersonEmailFieldToNotRemovable = (
    index: number,
    fields: any[]
): any => {
    const result: Record<string, any> = {};

    // get index of any other person email fields on the form
    const indexesOfOtherPersonEmailFields = fields
        .map((field, i) => {
            return field.fieldName === 'email' && field.entityType === 'CONTACT' ? i : undefined;
        })
        .filter((i) => typeof i === 'number' && i !== index);

    // if there is only one other person email field on the form, flag it as not removable
    if (
        indexesOfOtherPersonEmailFields.length === 1 &&
        typeof indexesOfOtherPersonEmailFields[0] === 'number'
    ) {
        const i = indexesOfOtherPersonEmailFields[0];
        result.index = i;
        result.updatedField = {
            ...fields[i],
            isRemovable: false,
            isRequired: true,
        };
    }

    return result;
};

export const updateExistingPersonEmailFields = (
    fields: any[],
    update: (arg1: number, arg2: any) => void
) => {
    const fieldData = setExistingPersonEmailFieldsToRemovable(fields);

    fieldData.forEach((field) => update(field.index, field.updatedField));
};

// Tested in email-field-helpers.spec.js
export const setExistingPersonEmailFieldsToRemovable = (fields: any[]): any[] => {
    // @ts-expect-error
    const result = [];

    const indexesOfPersonEmailFields: number[] = fields
        .map((field, i) => {
            return field.fieldName === 'email' && field.entityType === 'CONTACT' ? i : undefined;
        })
        .filter((item) => item !== undefined);

    indexesOfPersonEmailFields.forEach((i) => {
        const field = {
            index: i,
            updatedField: {...fields[i], isRemovable: true},
        } as const;

        result.push(field);
    });

    // @ts-expect-error
    return result;
};
